import AppShell from "../components/layout/AppShell";
import AppFooter from "../components/layout/AppFooter";
import TopNav from "../components/layout/TopNav";

import { useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:3001";

export default function MyAccount({ onLogout, onNavigate }) {
    const [profile, setProfile] = useState(null);
    const [cvFile, setCvFile] = useState(null);
    const [cvResult, setCvResult] = useState(null);
    const [loading, setLoading] = useState(false);
    const [checkingStatus, setCheckingStatus] = useState(true);
    const [kycStatus, setKycStatus] = useState('not_started');
    const [kycDocs, setKycDocs] = useState([]);
    const [kycFiles, setKycFiles] = useState({ identity: null, selfie: null, proof_of_address: null });
    const [kycLoading, setKycLoading] = useState(false);
    const [kycMessage, setKycMessage] = useState(null);

    const getHeaders = () => {
        const token = localStorage.getItem("token");
        return { Authorization: `Bearer ${token}` };
    };

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const res = await axios.get(`${API}/technicians/me/full`, { headers: getHeaders() });
                setProfile(res.data);
            } catch {
                setProfile(null);
            } finally {
                setCheckingStatus(false);
            }
        };
        fetchProfile();
        const fetchKyc = async () => {
            try {
                const res = await axios.get(`${API}/kyc/status`, { headers: getHeaders() });
                setKycStatus(res.data.status);
                setKycDocs(res.data.documents);
            } catch { }
        };
        fetchKyc();
    }, []);



    const uploadCV = async (e) => {
        e.preventDefault();
        if (!cvFile) return;
        setLoading(true);
        const formData = new FormData();
        formData.append("cv", cvFile);
        try {
            const res = await axios.post(`${API}/cv/upload`, formData, {
                headers: { ...getHeaders(), "Content-Type": "multipart/form-data" },
            });
            setCvResult(res.data);
            if (res.data?.validated) {
                setTimeout(() => window.location.reload(), 2000);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const uploadKyc = async (e) => {
        e.preventDefault();
        if (!kycFiles.identity || !kycFiles.selfie || !kycFiles.proof_of_address) {
            setKycMessage({ text: 'Les 3 documents sont requis.', type: 'error' });
            return;
        }
        setKycLoading(true);
        const formData = new FormData();
        formData.append('identity', kycFiles.identity);
        formData.append('selfie', kycFiles.selfie);
        formData.append('proof_of_address', kycFiles.proof_of_address);
        try {
            await axios.post(`${API}/kyc/upload`, formData, {
                headers: { ...getHeaders(), 'Content-Type': 'multipart/form-data' },
            });
            setKycMessage({ text: 'Documents soumis ! Vérification en cours.', type: 'success' });
            setKycStatus('pending');
        } catch (err) {
            setKycMessage({ text: 'Erreur lors de l\'envoi.', type: 'error' });
        }
        setKycLoading(false);
    };

    return (
        <AppShell header={<TopNav isLoggedIn={true} onLogout={onLogout} onNavigate={onNavigate} />} footer={<AppFooter onNavigate={onNavigate} />} onNavigate={onNavigate}>
            <div style={{ maxWidth: 700, margin: "0 auto" }}>
                <h2 className="page-title">Mon compte</h2>

                {checkingStatus ? (
                    <div className="section-card"><p className="muted">Chargement…</p></div>
                ) : profile ? (
                    <>
                        <div className="section-card">
                            <div className="section-head">
                                <h3 className="section-title">Profil technicien</h3>
                            </div>
                            <div className="card">
                                <div className="muted" style={{ fontSize: 12, marginBottom: 8 }}>{profile.email}</div>
                                <div className="tech-score">
                                    <span className="tech-score__value">{profile.score}</span>
                                    <span className="tech-score__max">/100</span>
                                </div>
                                <div className="tech-bar">
                                    <div
                                        className="tech-bar__fill"
                                        style={{ width: `${Math.max(0, Math.min(100, profile.score || 0))}%` }}
                                        data-score={profile.score}
                                    />
                                </div>
                                <div className="tech-meta" style={{ marginTop: 10 }}>
                                    <div>
                                        <span className="muted">Statut :</span>{" "}
                                        <strong style={{ color: profile.validated ? '#4caf50' : '#f59e0b' }}>
                                            {profile.validated ? '✓ Validé' : '⏳ En attente de validation'}
                                        </strong>
                                    </div>
                                    <div>
                                        <span className="muted">Disponible :</span>{" "}
                                        <strong>{profile.available ? 'Oui' : 'Non'}</strong>
                                    </div>
                                    {profile.skills?.length > 0 && (
                                        <div>
                                            <span className="muted">Compétences :</span>{" "}
                                            <strong>{profile.skills.join(", ")}</strong>
                                        </div>
                                    )}
                                </div>
                                <div>
                                    <span className="muted">Note clients :</span>{" "}
                                    {profile.note_moyenne ? (
                                        <strong>
                                            {[1, 2, 3, 4, 5].map(s => (
                                                <span key={s} style={{ color: s <= Math.round(profile.note_moyenne) ? '#f59e0b' : '#444' }}>★</span>
                                            ))}
                                            {" "}{profile.note_moyenne}/5
                                            <span className="muted" style={{ fontSize: 12 }}> ({profile.total_avis} avis)</span>
                                        </strong>
                                    ) : (
                                        <span className="muted">Aucun avis pour l'instant</span>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="section-card">
                            <div className="section-head">
                                <h3 className="section-title">Mettre à jour mon CV</h3>
                            </div>
                            <p className="muted" style={{ marginTop: 0 }}>
                                Soumets un nouveau CV pour mettre à jour ton score IA.
                            </p>
                            <form onSubmit={uploadCV} className="stack">
                                <div
                                    onClick={() => document.getElementById('cv-upload').click()}
                                    style={{
                                        padding: "12px 16px",
                                        borderRadius: 12,
                                        border: "1px dashed rgba(110,86,207,0.4)",
                                        background: "rgba(110,86,207,0.06)",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 10,
                                        fontSize: 13,
                                        color: "rgba(200,200,215,0.85)",
                                        transition: "all 160ms ease"
                                    }}
                                    onMouseEnter={e => e.currentTarget.style.borderColor = "rgba(110,86,207,0.7)"}
                                    onMouseLeave={e => e.currentTarget.style.borderColor = "rgba(110,86,207,0.4)"}
                                >
                                    <span style={{ fontSize: 18 }}>📄</span>
                                    <span>{cvFile ? cvFile.name : "Cliquer pour choisir un fichier PDF"}</span>
                                    <input
                                        id="cv-upload"
                                        type="file"
                                        accept=".pdf"
                                        style={{ display: "none" }}
                                        onChange={(e) => setCvFile(e.target.files?.[0] || null)}
                                    />
                                </div>
                                <button type="submit" disabled={loading || !cvFile} className="btn btn-primary">
                                    {loading ? "Analyse en cours..." : "Soumettre mon CV"}
                                </button>
                            </form>
                            {cvResult && (
                                <div className="card" style={{ marginTop: 16 }}>
                                    <div className="tech-score">
                                        <span className="tech-score__value">{cvResult.score}</span>
                                        <span className="tech-score__max">/100</span>
                                    </div>
                                    <div className="tech-bar">
                                        <div
                                            className="tech-bar__fill"
                                            style={{ width: `${Math.max(0, Math.min(100, cvResult.score || 0))}%` }}
                                            data-score={cvResult.score}
                                        />
                                    </div>
                                    {cvResult.red_flags?.length > 0 && (
                                        <div className="tech-warn">⚠️ {cvResult.red_flags.join(", ")}</div>
                                    )}
                                    {cvResult.validated ? (
                                        <div className="tech-ok">✓ Score suffisant — profil mis à jour</div>
                                    ) : (
                                        <div className="tech-bad">Score insuffisant.</div>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="section-card">
                            <div className="section-head">
                                <h3 className="section-title">Vérification d'identité (KYC)</h3>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
                                <span className="muted">Statut :</span>
                                {kycStatus === 'verified' && <span style={{ color: '#4ade80', fontWeight: 700 }}>✓ Vérifié</span>}
                                {kycStatus === 'pending' && <span style={{ color: '#fbbf24', fontWeight: 700 }}>⏳ En cours de vérification</span>}
                                {kycStatus === 'rejected' && <span style={{ color: '#f87171', fontWeight: 700 }}>✕ Refusé — veuillez resoumettre</span>}
                                {kycStatus === 'not_started' && <span style={{ color: '#888', fontWeight: 600 }}>Non vérifié</span>}
                            </div>

                            {kycMessage && (
                                <div className={`alert ${kycMessage.type === 'error' ? 'alert-error' : ''}`} style={{
                                    marginBottom: 16,
                                    ...(kycMessage.type !== 'error' ? {
                                        background: 'rgba(110,86,207,0.12)', borderColor: 'rgba(110,86,207,0.28)', color: '#a78bfa'
                                    } : {})
                                }}>
                                    {kycMessage.text}
                                </div>
                            )}

                            {(kycStatus === 'not_started' || kycStatus === 'rejected') && (
                                <form onSubmit={uploadKyc} className="stack">
                                    {[
                                        { key: 'identity', label: "Pièce d'identité", icon: '🪪' },
                                        { key: 'selfie', label: 'Selfie avec pièce d\'identité', icon: '🤳' },
                                        { key: 'proof_of_address', label: 'Justificatif de domicile', icon: '🏠' },
                                    ].map(doc => (
                                        <div key={doc.key}
                                            onClick={() => document.getElementById(`kyc-${doc.key}`).click()}
                                            style={{
                                                padding: '12px 16px', borderRadius: 12,
                                                border: `1px dashed ${kycFiles[doc.key] ? 'rgba(74,222,128,0.4)' : 'rgba(110,86,207,0.4)'}`,
                                                background: kycFiles[doc.key] ? 'rgba(74,222,128,0.06)' : 'rgba(110,86,207,0.06)',
                                                cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10,
                                                fontSize: 13, color: 'rgba(200,200,215,0.85)', transition: 'all 160ms ease'
                                            }}
                                        >
                                            <span style={{ fontSize: 18 }}>{doc.icon}</span>
                                            <div>
                                                <div style={{ fontWeight: 600 }}>{doc.label}</div>
                                                <div className="muted" style={{ fontSize: 11 }}>
                                                    {kycFiles[doc.key] ? `✓ ${kycFiles[doc.key].name}` : 'PDF, JPG ou PNG — max 10 Mo'}
                                                </div>
                                            </div>
                                            <input
                                                id={`kyc-${doc.key}`}
                                                type="file"
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                style={{ display: 'none' }}
                                                onChange={(e) => setKycFiles(f => ({ ...f, [doc.key]: e.target.files?.[0] || null }))}
                                            />
                                        </div>
                                    ))}
                                    <button type="submit" disabled={kycLoading} className="btn btn-primary">
                                        {kycLoading ? 'Envoi en cours...' : 'Soumettre mes documents'}
                                    </button>
                                </form>
                            )}

                            {kycStatus === 'pending' && kycDocs.length > 0 && (
                                <div style={{ fontSize: 13 }}>
                                    <p className="muted" style={{ marginBottom: 8 }}>Documents soumis :</p>
                                    {kycDocs.map(doc => (
                                        <div key={doc.id} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                                            <span style={{ color: '#fbbf24' }}>⏳</span>
                                            <span>{doc.type === 'identity' ? "Pièce d'identité" : doc.type === 'selfie' ? 'Selfie' : 'Justificatif de domicile'}</span>
                                            <span className="muted">— {doc.filename}</span>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {kycStatus === 'verified' && (
                                <p style={{ fontSize: 13, color: '#4ade80' }}>
                                    Votre identité a été vérifiée. Merci !
                                </p>
                            )}
                        </div>
                    </>
                ) : (
                    <div className="section-card">
                        <p className="muted">Vous n'avez pas encore de profil technicien.</p>
                        <button className="btn btn-primary" onClick={() => onNavigate("become-technician")}>
                            Devenir technicien
                        </button>
                    </div>
                )}
            </div>
        </AppShell>
    );
}